import React from 'react'
import PropTypes from 'prop-types';
import HelpTooltip from "components/HelpTooltip";
import BoldTypography from "components/BoldTypography";
import SwzGeneratorQuestionSelect from "./SwzGeneratorQuestionSelect";
import SwzGeneratorQuestionCheckbox from "./SwzGeneratorQuestionCheckbox";

function SwzGeneratorQuestion(
    {
        id,
        question,
        formikProps
    }) {
    return (<div>
            <BoldTypography>
                {question.text}
                {!!question.helpMessage && <HelpTooltip text={
                    new DOMParser().parseFromString(question.helpMessage, "text/html").documentElement.textContent}/>}
            </BoldTypography>
            {question.type === "checkbox" ?
                <SwzGeneratorQuestionCheckbox question={question} formikProps={formikProps}/>
                :
                <SwzGeneratorQuestionSelect question={question} formikProps={formikProps}/>
            }


        </div>
    )
}

SwzGeneratorQuestion.propTypes = {
    classes: PropTypes.any,
}

export default SwzGeneratorQuestion;